<template>
  <div ref="rootEl" class="support-component" :class="{active: open_contact_dialog}">
    <div class="support-component-title" :class="{active: open_contact_dialog}" @click="openContactDialog">
      <img src="../assets/menu-icon-close-black.svg" alt="">
    </div>
    <div class="support-component-settings " :class="{active: open_contact_dialog }">
      <v-btn large @click="phone_dialog = true" fab color="success">
        <v-icon>mdi-phone</v-icon>
      </v-btn>
      <v-btn large @click="openTelegram" fab color="success"><img src="/image/telegram_logo.png" width="64" alt="">
      </v-btn>
      <v-dialog width="500" v-model="phone_dialog">
        <v-card outlined rounded="xl">
          <v-card-title>Qo'ng'iroq qilish
            <v-spacer></v-spacer>
            <v-icon @click="phone_dialog = false">mdi-close</v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn block @click="openPhone" rounded color="success">
              <v-icon>mdi-phone</v-icon>
              +99890 126 80 68
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>

</template>

<script>
export default {
  name: "SupportComponent",
  data() {
    return {
      phone_dialog: false,
      open_contact_dialog: false,
    }
  },
  methods: {
    openPhone() {
      window.open("tel:+998901268068", "_blank")
    },
    openTelegram() {
      window.open("https://t.me/onlinemed_uz", "_blank")
    },
    openContactDialog() {
      this.open_contact_dialog = !this.open_contact_dialog
    },
    handleClickOutside(event) {
      const rootEl = this.$refs.rootEl;
      if (rootEl && !rootEl.contains(event.target)) {
        this.open_contact_dialog = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }
}
</script>

<style scoped>

.support-component {
  position: fixed;
  right: 0;
  bottom: 105px;
  display: flex;
  align-items: center;
}

.support-component-settings{
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: absolute;
  right: 20px;
}

.support-component-title{
  display: none;
}

@media (max-width: 1200px) {
  .support-component {
    position: fixed;
    bottom: 50%;
    right: 0;
    display: flex;
    align-items: center;
    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  .support-component-title {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 2);
  }

  .support-component-title.active{
    transform: rotate(180deg);
  }


  .support-component-settings {
    display: flex;
    flex-direction: column;
    gap: 20px;
    position: absolute;
    right: -200px;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 2);
  }

  .support-component.active{
    right: 100px;
  }

  .support-component-settings.active{
    right: -80px;
  }
}


</style>